import * as React from 'react';
import {cn} from 'src/lib/utils';

export const PopoverContents = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<'div'>
>((props, ref) => {
  // Forward the rest so callers can attach ARIA wiring (role="listbox", id)
  // without wrapping this in another element and breaking the layout.
  const {className, children, ...rest} = props;
  return (
    <div
      ref={ref}
      className={cn(
        'shadow-popover bg-popover text-popover-foreground outline-ring/50 max-h-[30vh] overflow-y-auto rounded-md outline-1',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

export const PopoverItem = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<'div'> & {isSelected: boolean}
>((props, ref) => {
  const {isSelected, className, children, ...rest} = props;
  return (
    <div
      ref={ref}
      className={cn('px-3 py-2', isSelected && 'bg-accent', className)}
      {...rest}
    >
      {children}
    </div>
  );
});
